import axios from 'axios';
import { API_URL } from 'app/utils/common/constants';
import { Response } from 'setup/axios/HttpResponse';
import {
  MerchantOnboardingPrefill,
  MerchantOnboardingResult,
  MerchantOnboardingStatusResult,
  RegenerateMerchantOnboardingSessionRequest,
  StartMerchantOnboardingRequest,
} from '../models';

// API_URL already carries the tenant segment.
const BASE = `${API_URL}/api/v2/payments/merchants/onboarding`;

const merchantOnboardingApi = {
  getPrefill(): Promise<Response<MerchantOnboardingPrefill>> {
    return axios.get(`${BASE}/prefill`);
  },
  getStatus(): Promise<Response<MerchantOnboardingStatusResult>> {
    return axios.get(`${BASE}/status`);
  },
  startOnboarding(body: StartMerchantOnboardingRequest): Promise<Response<MerchantOnboardingResult>> {
    return axios.post(BASE, body, { headers: { 'toast-message': 'false' } });
  },
  regenerateSession(
    body: RegenerateMerchantOnboardingSessionRequest
  ): Promise<Response<MerchantOnboardingResult>> {
    return axios.post(`${BASE}/session`, body, { headers: { 'toast-message': 'false' } });
  },
};

export { merchantOnboardingApi };
